module.exports = __webpack_public_path__ + "26d188e88a801ef36f645665f0eb8f33.svg";